import React from 'react';
import styled from 'styled-components';

import WP from 'WP';

import GridElement from 'partials/GridElement';
import Html from 'partials/Html';

import Media from 'css/Media';

const SuccessForm = props => {

    const getSum = () => {
        //Calculate order total
        let sumArr = [];
        props.rentals.map(product => sumArr.push(product.total));

        let sum = sumArr.reduce((acc, num) => acc + num);
        return sum;
    }

    const {
        rentals,
        date,
        days, 
        personalia,
    } = props;

    return (
            <FormGrid id="form">
                <TitleGridElement
                    colStart={{default: 1, s: 3, m: 3}}
                    colEnd={{default: 8, s: 14, m: 14}}
                    rowStart={1}
                >
                    <h4>{WP.trans.reservationConfirmation}</h4>
                </TitleGridElement>
                <GridElement
                    colStart={{default: 1, s: 3, m: 3}}
                    colEnd={{default: 8, s: 14, m: 14}}
                    rowStart={2}
                >
                    <Html content>{WP.options.snowmobile_form_success_text}</Html>
                </GridElement>
                <ReservationDetailsGridElement
                    colStart={{default: 1, s: 3}}
                    colEnd={{default: 8, s: 14}}
                    rowStart={3}
                >
                    <TitleSpan>{WP.trans.reservationDetails}</TitleSpan>
                        {rentals.map((rental,idx) => {
                            return(
                                <SingleOrder key={idx}>
                                    <span>{rental.name}</span>
                                    <FlexBox>
                                        <span>{date}</span>
                                        <span>{`${days} ${WP.trans.days}`}</span>
                                    </FlexBox>
                                    <span>{'NOK ' + rental.rentalPrice}</span>
                                    {rental.insurance > 0 && 
                                        <StyledDiv>
                                            <span>{WP.trans.insurance}</span>
                                            <span>{'NOK ' + rental.insurance}</span>
                                        </StyledDiv>
                                    }
                                    { rental.earlyPickup > 0 &&
                                        <StyledDiv>
                                            <span>{WP.trans.earlyPickup}</span>
                                            <span>{'NOK ' + rental.earlyPickup}</span>
                                        </StyledDiv>
                                    }
                                    { rental.clothing > 0 &&
                                        <StyledDiv>
                                            <span>{WP.trans.clothing}</span>
                                            <span>{'NOK ' + rental.clothing}</span>
                                        </StyledDiv>
                                    }
                                </SingleOrder>
                            )
                        })}    
                </ReservationDetailsGridElement>
                <TotalPriceGridElement
                    colStart={{default: 1, s: 3, m: 3}}
                    colEnd={{default: 8, s: 14, m: 14}}
                    rowStart={4}
                >
                    <span>{WP.trans.totalPrice}</span> 
                    <span>{'NOK ' + getSum()}</span>
                </TotalPriceGridElement>
                <PersonaliaGridElement
                    colStart={{default: 1, s: 3}}
                    colEnd={{default: 8, s: 14}}
                    rowStart={5}
                >
                    <span>{personalia.firstName + ' ' + personalia.lastName}</span>
                    <span>{personalia.email}</span>
                    <span>{personalia.phone}</span>
                    <span>{personalia.adress}</span>
                    <FlexBox>
                        <span>{personalia.postalCode}</span>
                        <span>{personalia.city}</span>
                    </FlexBox>
                </PersonaliaGridElement>
            </FormGrid>
    )
}


export default SuccessForm;

const FormGrid = styled.div`
    display: -ms-grid;
    display: grid;
    -ms-grid-columns: (1fr .359fr)[3] 1fr;
    grid-template-columns: repeat(3, 1fr .359fr) 1fr;
    -ms-grid-rows: ${props => props.rows || 'auto'};
    grid-template-rows: ${props => props.rows || 'auto'};
    margin-bottom: ${props => props.theme.spacing.elementM};

    ${Media.greaterThan('s')`
        -ms-grid-columns: (1fr .67fr)[7] 1fr;
        grid-template-columns: repeat(7, 1fr .67fr) 1fr;
        padding: ${props => props.theme.spacing.elementL} 0 ${props => props.theme.spacing.blockM};
        margin-bottom: ${props => props.theme.spacing.blockL};
        border: 1px solid ${props => props.theme.colors.text};
    `}

    ${Media.greaterThan('m')`
        -ms-grid-columns: (1fr .435fr)[7] 1fr;
        grid-template-columns: repeat(7, 1fr .435fr) 1fr;
    `}

    span {
        display: block;
        font-size: 14px;
        line-height: 23px;

        ${Media.greaterThan('s')`
            line-height: 25px;
        `}
    }
    
    p {
        font-size: 16px;
        line-height: 28px;
    }
`

const TitleGridElement = styled(GridElement)`
    padding-bottom: ${props => props.theme.spacing.contentL};

    ${Media.greaterThan('s')`
        padding-bottom: ${props => props.theme.spacing.contentXL};
    `}
`

const ReservationDetailsGridElement = styled(GridElement)`
`

const TitleSpan = styled.span`
    ${Media.greaterThan('s')`
        padding-bottom: ${props => props.theme.spacing.contentL};
    `}
`

const TotalPriceGridElement = styled(GridElement)`
    padding-bottom: ${props => props.theme.spacing.contentL};

    ${Media.greaterThan('s')`
        padding-bottom: ${props => props.theme.spacing.contentXL};
    `}
`

const PersonaliaGridElement = styled(GridElement)`
    padding-bottom: ${props => props.theme.spacing.contentL};

    ${Media.greaterThan('s')`
        padding-bottom: ${props => props.theme.spacing.contentXL};
    `}
`


const FlexBox = styled.div`
    display: flex;

    span {
        margin-right: 5px;
    }
`

const SingleOrder = styled.div`
     padding-bottom: ${props => props.theme.spacing.contentL};

    ${Media.greaterThan('s')`
        padding-bottom: ${props => props.theme.spacing.contentXL};
    `}
`

const StyledDiv = styled.div`
    ${Media.greaterThan('s')`
        margin: ${props => props.theme.spacing.contentL} 0;

        &:last-of-type {
            margin-bottom: 0;
        }
    `}
`